export default "__VITE_ASSET__JLVaDCCe__"